// <auto-generated>
// Generated from docs/seo/copy.json by frontend/scripts/gen-seo-copy.mts.
// Edit the JSON and run `npm run seo:copy`; CI fails when this file is stale.
// </auto-generated>

export interface SeoFaq { readonly q: string; readonly a: string }

export interface SeoSection {
  readonly id: string
  readonly h2: string
  readonly p: readonly string[]
}

export interface SeoEntry {
  readonly noindex?: boolean
  readonly title: string
  readonly description: string
  readonly h1: string
  readonly eyebrow: string
  readonly h2: Readonly<Record<string, string>>
  readonly faq: readonly SeoFaq[]
  readonly sections?: readonly SeoSection[]
}

export const SEO_SITE_NAME = "Must Have AI"

export const SEO_DISCLAIMER = "Must Have AI is a parody and is not affiliated with, endorsed by or connected to OpenAI, Anthropic or Google. Every outage shown here is read from the provider's own public status page."

export const SEO_METHOD = "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."

export const SEO_COPY: Readonly<Record<string, SeoEntry>> = {
  "home": {
    "title": "Is ChatGPT, Claude or Gemini Down? | Must Have AI",
    "description": "Live status for OpenAI, Anthropic and Google, read from their own status pages. See which AI provider is down right now, and press a button about it.",
    "h1": "{live_headline}",
    "eyebrow": "",
    "h2": {
      "providers": "Right now",
      "more": "Dig into the record"
    },
    "faq": [
      {
        "q": "Is OpenAI down right now?",
        "a": "{openai_answer}"
      },
      {
        "q": "Is Claude down right now?",
        "a": "{anthropic_answer}"
      },
      {
        "q": "Is Gemini down right now?",
        "a": "{google_answer}"
      },
      {
        "q": "How quickly does this page notice an outage?",
        "a": "{poll_answer}"
      }
    ]
  },
  "history": {
    "title": "AI Outage History & Uptime | Must Have AI",
    "description": "Every recorded outage for OpenAI, Anthropic and Google: ninety days of uptime, the longest incidents on record, and which provider falls over most.",
    "h1": "AI outage history",
    "eyebrow": "",
    "h2": {
      "uptime": "90 days of uptime",
      "records": "Records",
      "biggest": "Biggest outages",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Which AI provider is down the most?",
        "a": "{worst_answer}"
      },
      {
        "q": "How far back does this history go?",
        "a": "{coverage_answer}"
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      }
    ]
  },
  "codex": {
    "title": "Codex Resets — When Does Codex Reset? | Must Have AI",
    "description": "Every Codex usage-limit reset OpenAI has granted, the average gap between them, and how long it has been since the last one. Updated as they happen.",
    "h1": "Codex resets",
    "eyebrow": "",
    "h2": {
      "since": "Time since the last reset",
      "numbers": "The numbers",
      "calendar": "When they landed",
      "months": "Resets per month",
      "timeline": "Every announcement",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "When does Codex reset?",
        "a": "{when_answer}"
      },
      {
        "q": "How long since the last Codex reset?",
        "a": "{since_answer}"
      },
      {
        "q": "What counts as a reset here?",
        "a": "Only a hard reset or a banked reset — the two that actually put usage back. Credit grants, promos and boosts are recorded on the timeline and shown, but never counted in the averages, because they did not reset anything."
      },
      {
        "q": "Where do these announcements come from?",
        "a": "From the Codex lead's own public posts, recorded as they happen. Every entry links to its source."
      }
    ]
  },
  "about": {
    "title": "About Must Have AI — How We Measure AI Uptime",
    "description": "A parody status site for OpenAI, Anthropic and Google: how the uptime is measured, where every figure comes from, and which parts are the joke.",
    "h1": "About Must Have AI",
    "eyebrow": "",
    "h2": {
      "affiliation": "Not affiliated",
      "how": "How it works",
      "measure": "How we measure uptime",
      "sources": "Data sources",
      "privacy": "Privacy",
      "api": "API and feed"
    },
    "faq": []
  },
  "api-docs": {
    "title": "Public API — live AI status as JSON | Must Have AI",
    "description": "The public Must Have AI API: live status, uptime and incidents for OpenAI, Anthropic and Google as JSON. CORS-open, no key, cached, with a curl line each.",
    "h1": "Public API",
    "eyebrow": "Read-only · no key · CORS-open",
    "h2": {
      "using": "Using it",
      "endpoints": "Every endpoint"
    },
    "faq": []
  },
  "notfound": {
    "noindex": true,
    "title": "Page not found — Must Have AI",
    "description": "This page does not exist. The live status of OpenAI, Anthropic and Google is on the home page.",
    "h1": "Page not found",
    "eyebrow": "",
    "h2": {},
    "faq": []
  },
  "v2": {
    "noindex": true,
    "title": "Must Have AI — the walls variant",
    "description": "The same live AI status as the home page, drawn with three walls per provider. A rendering variant, not a separate page.",
    "h1": "{live_headline}",
    "eyebrow": "",
    "h2": {},
    "faq": []
  },
  "status.openai": {
    "title": "OpenAI Status — Is OpenAI Down? | Must Have AI",
    "description": "Is OpenAI down right now? Live status, uptime over 24 hours to 90 days, and every incident OpenAI has published, read from their own status page.",
    "h1": "OpenAI Status",
    "eyebrow": "Service status",
    "h2": {
      "now": "Is OpenAI down right now?",
      "uptime": "OpenAI uptime",
      "components": "OpenAI components",
      "incidents": "Recent OpenAI incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is OpenAI down today?",
        "a": "{today_answer}"
      },
      {
        "q": "How often is OpenAI down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "Which OpenAI services does this cover?",
        "a": "Every component OpenAI publishes on its own status page — ChatGPT, the API, Codex and the rest. Each one has its own strip and its own uptime figure above."
      },
      {
        "q": "Where does this OpenAI status data come from?",
        "a": "From OpenAI's own published status page, polled on a schedule and recorded here. The source link is at the foot of this page. Where this page and theirs disagree, theirs is right: this one is downstream and can only ever be later."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      },
      {
        "q": "What is Must Have AI?",
        "a": "A parody status site: three AI providers, one cartoon town, and a button to press when one of them falls over. The outages are real; the zombies are not. Must Have AI is a parody and is not affiliated with, endorsed by or connected to OpenAI, Anthropic or Google. Every outage shown here is read from the provider's own public status page."
      }
    ]
  },
  "status.anthropic": {
    "title": "Anthropic Status — Is Claude Down? | Must Have AI",
    "description": "Is Claude down right now? Live status, uptime over 24 hours to 90 days, and every incident Anthropic has published, read from their own status page.",
    "h1": "Anthropic Status",
    "eyebrow": "Service status",
    "h2": {
      "now": "Is Claude down right now?",
      "uptime": "Anthropic uptime",
      "components": "Anthropic components",
      "incidents": "Recent Anthropic incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is Claude down today?",
        "a": "{today_answer}"
      },
      {
        "q": "How often is Anthropic down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "Which Anthropic services does this cover?",
        "a": "Every component Anthropic publishes on its own status page — claude.ai, the API and Claude Code. Each one has its own strip and its own uptime figure above."
      },
      {
        "q": "Where does this Anthropic status data come from?",
        "a": "From Anthropic's own published status page, polled on a schedule and recorded here. The source link is at the foot of this page. Where this page and theirs disagree, theirs is right: this one is downstream and can only ever be later."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      },
      {
        "q": "What is Must Have AI?",
        "a": "A parody status site: three AI providers, one cartoon town, and a button to press when one of them falls over. The outages are real; the zombies are not. Must Have AI is a parody and is not affiliated with, endorsed by or connected to OpenAI, Anthropic or Google. Every outage shown here is read from the provider's own public status page."
      }
    ]
  },
  "status.google": {
    "title": "Google AI Status — Is Gemini Down? | Must Have AI",
    "description": "Is Gemini down right now? Live status, uptime over 24 hours to 90 days, and every incident Google has published, read from their own status page.",
    "h1": "Google AI Status",
    "eyebrow": "Service status",
    "h2": {
      "now": "Is Gemini down right now?",
      "uptime": "Google uptime",
      "components": "Google components",
      "incidents": "Recent Google incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is Gemini down today?",
        "a": "{today_answer}"
      },
      {
        "q": "How often is Google down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "Which Google services does this cover?",
        "a": "Every component Google publishes on its own status page — Gemini and the AI products on Google Cloud. Each one has its own strip and its own uptime figure above."
      },
      {
        "q": "Where does this Google status data come from?",
        "a": "From Google's own published status page, polled on a schedule and recorded here. The source link is at the foot of this page. Where this page and theirs disagree, theirs is right: this one is downstream and can only ever be later."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      },
      {
        "q": "What is Must Have AI?",
        "a": "A parody status site: three AI providers, one cartoon town, and a button to press when one of them falls over. The outages are real; the zombies are not. Must Have AI is a parody and is not affiliated with, endorsed by or connected to OpenAI, Anthropic or Google. Every outage shown here is read from the provider's own public status page."
      }
    ]
  },
  "status.chatgpt": {
    "title": "ChatGPT Status — Is ChatGPT Down? | Must Have AI",
    "description": "Is ChatGPT down right now? Live ChatGPT status, uptime over 24 hours to 90 days, and every incident OpenAI has published for it, from their own status page.",
    "h1": "ChatGPT Status",
    "eyebrow": "Service status · not affiliated",
    "h2": {
      "now": "Is ChatGPT down right now?",
      "uptime": "ChatGPT uptime",
      "components": "ChatGPT components",
      "incidents": "Recent ChatGPT incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is ChatGPT down today?",
        "a": "{today_answer}"
      },
      {
        "q": "Is it just me, or is ChatGPT down?",
        "a": "{today_answer} If this page says operational and it is still not working for you, the problem is more likely to be local — OpenAI only publishes an incident once it has confirmed one, which is usually minutes after the first reports."
      },
      {
        "q": "Why is ChatGPT not working?",
        "a": "{why_answer}"
      },
      {
        "q": "How often is ChatGPT down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "What does this page cover?",
        "a": "Only the ChatGPT components OpenAI publishes — conversations, login, voice, search and the rest of the ChatGPT group. The rest of OpenAI's services are on its own status page, linked above."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      }
    ]
  },
  "status.codex": {
    "title": "Codex Status — Is Codex Down? | Must Have AI",
    "description": "Is Codex down right now? Live Codex status, uptime over 24 hours to 90 days, and every incident OpenAI has published for it, from their own status page.",
    "h1": "Codex Status",
    "eyebrow": "Service status · not affiliated",
    "h2": {
      "now": "Is Codex down right now?",
      "uptime": "Codex uptime",
      "components": "Codex components",
      "incidents": "Recent Codex incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is Codex down today?",
        "a": "{today_answer}"
      },
      {
        "q": "Is it just me, or is Codex down?",
        "a": "{today_answer} If this page says operational and it is still not working for you, the problem is more likely to be local — OpenAI only publishes an incident once it has confirmed one, which is usually minutes after the first reports."
      },
      {
        "q": "Why is Codex not working?",
        "a": "{why_answer}"
      },
      {
        "q": "How often is Codex down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "What does this page cover?",
        "a": "Only the Codex components OpenAI publishes — the Codex CLI, the IDE extension and Codex in the ChatGPT apps. The rest of OpenAI's services are on its own status page, linked above."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      }
    ]
  },
  "status.claude": {
    "title": "Claude Status — Is Claude Down? | Must Have AI",
    "description": "Is Claude down right now? Live Claude status, uptime over 24 hours to 90 days, and every incident Anthropic has published for it, from their own status page.",
    "h1": "Claude Status",
    "eyebrow": "Service status · not affiliated",
    "h2": {
      "now": "Is Claude down right now?",
      "uptime": "Claude uptime",
      "components": "Claude components",
      "incidents": "Recent Claude incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is Claude down today?",
        "a": "{today_answer}"
      },
      {
        "q": "Is it just me, or is Claude down?",
        "a": "{today_answer} If this page says operational and it is still not working for you, the problem is more likely to be local — Anthropic only publishes an incident once it has confirmed one, which is usually minutes after the first reports."
      },
      {
        "q": "Why is Claude not working?",
        "a": "{why_answer}"
      },
      {
        "q": "How often is Claude down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "What does this page cover?",
        "a": "Only the Claude components Anthropic publishes — claude.ai, Claude Code and Claude Cowork — not the API, which is on Anthropic's page. The rest of Anthropic's services are on its own status page, linked above."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      }
    ]
  },
  "status.gemini": {
    "title": "Gemini Status — Is Gemini Down? | Must Have AI",
    "description": "Is Gemini down right now? Live Gemini status, uptime over 24 hours to 90 days, and every incident Google has published for it, from their own status page.",
    "h1": "Gemini Status",
    "eyebrow": "Service status · not affiliated",
    "h2": {
      "now": "Is Gemini down right now?",
      "uptime": "Gemini uptime",
      "components": "Gemini components",
      "incidents": "Recent Gemini incidents",
      "faq": "FAQ"
    },
    "faq": [
      {
        "q": "Is Gemini down today?",
        "a": "{today_answer}"
      },
      {
        "q": "Is it just me, or is Gemini down?",
        "a": "{today_answer} If this page says operational and it is still not working for you, the problem is more likely to be local — Google only publishes an incident once it has confirmed one, which is usually minutes after the first reports."
      },
      {
        "q": "Why is Gemini not working?",
        "a": "{why_answer}"
      },
      {
        "q": "How often is Gemini down?",
        "a": "{thirty_day_answer}"
      },
      {
        "q": "What does this page cover?",
        "a": "Only the Gemini components Google publishes — Gemini and the Gemini surfaces Google publishes. The rest of Google's services are on its own status page, linked above."
      },
      {
        "q": "How is uptime calculated?",
        "a": "Uptime counts only major and critical incidents against a provider. Degraded time is reported beside it and never subtracted, because a slow hour is not a lost hour. Overlapping incidents are counted once, days are UTC days, and every figure comes from the provider's own published status page — where the two disagree, theirs is right."
      }
    ]
  },
  "ads.terms": {
    "noindex": true,
    "title": "Advertiser terms — Must Have AI",
    "description": "What an advertising sign on Must Have AI may say, who reviews it, how it is billed and cancelled, and what happens to the one address an advertiser gives us.",
    "h1": "Advertiser terms",
    "eyebrow": "Six signs · every one reviewed before it shows",
    "h2": {},
    "faq": [],
    "sections": [
      {
        "id": "ads-terms-what",
        "h2": "What an ad is",
        "p": [
          "An ad on this site is a wooden sign board standing beside a road in the painted theme of the home page, and there are six of them. It comes in one of two forms, chosen when you buy it. Either a small picture and up to three short lines of text, which we lay out on the board: the picture is redrawn to a fixed 320 by 160 pixels, and the lines are limited to 32, 40 and 40 characters and are plain text. Or one picture of your own filling the whole board, with no lines at all: it is redrawn to a fixed 400 by 228 pixels by scaling it to fill and taking the middle, so a picture that is not about twice as wide as it is tall loses its edges, and the purchase dialog shows you the result before you pay. Either way it is a still image — no animation, no video, no sound — and the same content rules below apply to whatever is in it, words and picture alike. The board’s painted frame casts its shadow across it, as it does across ours.",
          "Every board is marked “Ad”. Its link leaves through a redirect on this site, so the click can be counted and tagged with UTM parameters you will see in your own analytics. A click on an ad is never counted as a MUST HAVE AI click, and no ad ever runs a script, sets a cookie or loads anything from another domain.",
          "Slots are sold by the month in three tiers, and the price of each is stated in the purchase dialog before you pay. A Dedicated slot is on every page impression; Gold and Silver slots rotate, so a sold ad in one of those tiers is shown on a share of impressions that falls as more ads in that tier are sold. The six slots are shuffled across the six board positions on every impression, so no advertiser is tied to any one company’s square."
        ]
      },
      {
        "id": "ads-terms-rules",
        "h2": "What an ad may not contain",
        "p": [
          "No company logo, wordmark, trademarked shape, or anything else that suggests you are OpenAI, Anthropic or Google, are endorsed by them, or are connected to them. This site is a parody and says so on every page; an ad that borrowed a real brand would make that disclaimer untrue.",
          "No adult content, gambling, cryptocurrency schemes, malware, deceptive claims, impersonation of anyone, or anything unlawful where this site is read.",
          "The three lines are plain text and carry no second address: no markup, and no domain or URL written into the copy, because the board already carries your link.",
          "The destination has to be a working https:// page that is yours to advertise, and it has to stay the page the ad promises. Redirecting an approved ad somewhere else after review is the one thing here that will take a sign down without warning."
        ]
      },
      {
        "id": "ads-terms-review",
        "h2": "Review, and the right to take an ad down",
        "p": [
          "Every creative is read by the owner of this site before it is shown, and so is every later edit. Nothing you submit is public until it has been approved; while an edit is in review, the previously approved creative keeps running.",
          "The owner may refuse a creative, or take a running ad down, for the rules above or for anything else that would make the site worse. Either way you are told by email, with the reason."
        ]
      },
      {
        "id": "ads-terms-billing",
        "h2": "Price, billing and cancellation",
        "p": [
          "The price is per calendar month, in euro, and is shown in the purchase dialog beside the tier you pick. What you see there is what PayPal will charge.",
          "Billing is a PayPal subscription. PayPal takes the first payment when you approve it and repeats it every month until the subscription is cancelled; this site never sees your card.",
          "You can cancel at any time, from the manage link in your email or from your own PayPal account. A price change is a new plan — an existing subscription keeps the price it was bought at."
        ]
      },
      {
        "id": "ads-terms-money",
        "h2": "Refunds, VAT and invoices",
        "p": [
          "These are the money rules, and the last of them is the one still moving: the VAT position is not settled. If any of this matters to your decision, ask before you buy rather than after — the address at the bottom of this page reaches a person.",
          "A creative that is refused in review is refunded in full, within five working days of the decision.",
          "A cancellation stops the next renewal. The sign runs to the end of the month already paid for and that month is not refunded; an ad taken down for breaking the content rules above is not refunded either.",
          "Prices are shown in euro. The VAT position of this programme has not been decided, so the sentence that will state it cannot be written yet; whichever way it lands, the price shown in the dialog is the amount PayPal charges.",
          "Invoices are not issued automatically. Ask for one by replying to any email this programme sends you, and it will be written by hand."
        ]
      },
      {
        "id": "ads-terms-data",
        "h2": "What is kept, and for how long",
        "p": [
          "The only personal data an advertiser gives this site is one contact email address. It is used for the receipt, the manage link, review decisions and billing notices. It is never shown on the site, never sold, never shared, and never appears in any public response.",
          "It is deleted within {purge} days of the ad ending, whatever ended it. What remains after that is a daily count of impressions and clicks with nothing identifying in it — the same counts the manage page shows you while the ad runs.",
          "PayPal is the payment processor and holds the payment details; nothing about the payer is stored here. This site keeps no advertiser account and sets no cookie for one until a magic link from one of these emails is followed."
        ]
      },
      {
        "id": "ads-terms-contact",
        "h2": "Contact",
        "p": [
          "Questions about an ad, an invoice or a take-down: reply to any email this programme sends you, or write to contact@must-have.ai."
        ]
      }
    ]
  },
  "ads.manage": {
    "noindex": true,
    "title": "Manage your sign",
    "description": "Where an advertiser reads their sign's numbers, changes its words or cancels it, reached only from the link in an email.",
    "h1": "Manage your sign",
    "eyebrow": "",
    "h2": {},
    "faq": [],
    "sections": []
  },
  "ads.review": {
    "noindex": true,
    "title": "Review the signs",
    "description": "Where the owner looks at every sign waiting for a decision, drawn as the board a visitor would see, and approves or declines it.",
    "h1": "Signs waiting for review",
    "eyebrow": "",
    "h2": {},
    "faq": [],
    "sections": []
  },
  "ads.return": {
    "noindex": true,
    "title": "Payment received — Must Have AI",
    "description": "PayPal is confirming your advertising subscription. When it has, you get an email with the link that manages the ad.",
    "h1": "Your ad is being confirmed",
    "eyebrow": "",
    "h2": {},
    "faq": [],
    "sections": [
      {
        "id": "ads-return-next",
        "h2": "What happens next",
        "p": [
          "PayPal is confirming the subscription. That usually takes a few seconds and sometimes a few minutes, and it finishes whether or not this page stays open.",
          "When it is confirmed you get an email with a link that manages the ad — its numbers, its creative, and the button that cancels it.",
          "Every ad is read by the owner before it appears on a sign. Nothing you wrote is public yet; you will be told by email when it is approved, or why it was not.",
          "This page changes nothing. It only asks the site what state the ad is in — PayPal is the only thing that can move it forward."
        ]
      }
    ]
  },
  "ads.cancel": {
    "noindex": true,
    "title": "Nothing was charged — Must Have AI",
    "description": "The advertising subscription was not approved, so nothing was charged. The slot stays held for a short while and then goes back on sale.",
    "h1": "Nothing was charged",
    "eyebrow": "",
    "h2": {},
    "faq": [],
    "sections": [
      {
        "id": "ads-cancel-held",
        "h2": "The slot is held for a little longer",
        "p": [
          "You left PayPal without approving the subscription, so no payment was asked for and none was taken. There is nothing to refund and nothing to cancel.",
          "The slot you picked is held for {hold} minutes from when you started. Come back before then and it is still there; after that it goes back on sale for anyone.",
          "What you typed is stored only to hold that slot. It is shown to nobody, and it is erased within {purge} days of the hold expiring."
        ]
      }
    ]
  }
} as const

export interface SeoProduct {
  readonly slug: string
  readonly label: string
  readonly parent: string
  readonly match: { readonly kind: 'group' | 'name' | 'prefix'; readonly values: readonly string[] }
}

export const SEO_PRODUCTS: readonly SeoProduct[] = [
  {
    "slug": "chatgpt",
    "label": "ChatGPT",
    "parent": "openai",
    "match": {
      "kind": "group",
      "values": [
        "ChatGPT"
      ]
    }
  },
  {
    "slug": "codex",
    "label": "Codex",
    "parent": "openai",
    "match": {
      "kind": "group",
      "values": [
        "Codex"
      ]
    }
  },
  {
    "slug": "claude",
    "label": "Claude",
    "parent": "anthropic",
    "match": {
      "kind": "name",
      "values": [
        "claude.ai",
        "Claude Code",
        "Claude Cowork"
      ]
    }
  },
  {
    "slug": "gemini",
    "label": "Gemini",
    "parent": "google",
    "match": {
      "kind": "prefix",
      "values": [
        "Gemini"
      ]
    }
  }
] as const
